/* global WHITELABEL */
import con from '@services/connection'
import { configuracoes } from '@constants/URL'
import store from '@state/store'

/**
 * Verificar se ja passou certo tempo da data
 * @param {Date} date Data base para comparacao
 * @param {Number} min Tempo minimo considerado
 * @returns {Boolean} Passou mais de <min> minutos de <date>
 */
const hasDiff = (date, min) => {
  if (!date) {
    return true
  }
  return new Date() - date >= min * 60000
}

const carregarDados = async (commit) => {
  commit('SET_LOADING', true)

  const r = await con.get(configuracoes.classes_estrategicas.manage)

  if (r && r.status === 200) {
    commit('SAVE_LIST', r.value)
    commit('SAVE_MAPPER', r._mapper)
  }

  commit('SET_LOADING', false)
}

const carregar = ({ commit }) => {
  if (store.getters['subclasse/loading']) {
    console.log('Já está carregando as subclasses')
    return
  }

  if (!hasDiff(store.getters['subclasse/dataAtualizacao'], 5)) {
    console.log('Subclasses coletadas recentemente')
    return
  }

  if ((store.getters['user/currentUser'] || {}).IS_CLIENTE) {
    console.log('Acesso bloqueado para clientes')
    return
  }

  if (!WHITELABEL) {
    console.log('Acesso bloqueado para não-whitelabel')
    return
  }

  carregarDados(commit)
}

const add = ({ commit }, sub) => {
  commit('ADD_SUBCLASS', sub)
}

const remove = ({ commit }, sub) => {
  commit('REMOVE_SUBCLASS', sub)
}

const save_list = ({ commit }, sub) => {
  commit('SAVE_LIST', sub)
}

const save_mapper = ({ commit }, sub) => {
  commit('SAVE_MAPPER', sub)
}

export { carregar, add, remove, save_list, save_mapper }
